import { initializeApp, getApps } from "firebase/app";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { appEnv } from "@config/env";

const app = getApps().length > 0 ? getApps()[0]! : initializeApp({
  apiKey: appEnv.firebase.apiKey,
  authDomain: appEnv.firebase.authDomain,
  projectId: appEnv.firebase.projectId,
  storageBucket: appEnv.firebase.storageBucket,
  appId: appEnv.firebase.appId,
  messagingSenderId: appEnv.firebase.messagingSenderId,
  measurementId: appEnv.firebase.measurementId,
});

const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(() => {
  /* persistence is best-effort */
});
auth.useDeviceLanguage();

const firestore = getFirestore(app);
const functions = getFunctions(app, appEnv.firebase.region);

export const firebase = {
  app,
  auth,
  firestore,
  functions,
};
